module.exports = __webpack_public_path__ + "img/poly-8.0c944504.png";